module.exports = __webpack_public_path__ + "static/img/p1-t3.526a03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-t3.png
// module id = 5H2r
// module chunks = 0